import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ANALYSISTABS } from '../common/constants/labels';
import { PivotDefectMode, PivotTableDetails } from '../common/models/incident-dashboard-filterparameterdata';

@Injectable({
    providedIn: 'root'
})
export class ExcelService {


    generateExcel(data: Array<PivotDefectMode>) {
        const header = ['Defect MODE Aggregation (Level 1+2+3+4)', 'Level0', '4Ms', 'Production line', 'Defect Priority Index', 'PDCA Status', 'Occurances', 'DPI Defect Class', 'Defect Severity', 'Sub Region', 'Sites', 'Business Group'];

        const datalist: Array<string[]> = [];
        let obj: string[];
        data.forEach(x => {
            obj = [];
            obj.push(x.defectmodeaggregation);
            obj.push(x.leveL0);
            obj.push(x.fourms);
            // obj.push(x.recordid);
            obj.push(x.productionline);
            obj.push(x.defectpriorityindex.toString());
            obj.push(x.pdcastatus);
            obj.push(x.occurances.toString());
            obj.push(x.dpidefectclass);
            obj.push(x.defectseveritygrade);
            obj.push(x.subregion);
            obj.push(x.sites);
            obj.push(x.businessgroup);
            datalist.push(obj);
        });
        // Create workbook and worksheet
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Visualization');
        // Add Header Row
        const headerRow = worksheet.addRow(header);
        // Cell Style : Fill and Border
        headerRow.eachCell((cell, num) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add Data and Conditional Formatting
        datalist.forEach(d => {
            const row = worksheet.addRow(d);
            const qty = row.getCell(8);
            let color = 'FFFFFF';
            if (+qty.value < 500) {
                color = 'FFFFFF';
            }

            qty.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: color }
            };
        }
        );
        worksheet.getColumn(3).width = 30;
        worksheet.getColumn(4).width = 30;
        worksheet.addRow([]);
        // Footer Row
        const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
        footerRow.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' }
        };
        footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Merge Cells
        worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

        // Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((datalistExcel: any) => {
            const blob = new Blob([datalistExcel], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, 'VisualizationReport.xlsx');
        });
    }

    generateExcelForProjectStatusReport(data: Array<PivotTableDetails>) {
        const header = ['Agreement Remarks Date', 'Cluster', 'Site', 'Big Category', 'Loss Tree', 'RecordID', 'Production Line', 'Defect Priority Index', 'PDCA Status', 'Occurances', 'Agreement', 'Remarks', 'User'];

        const datalist: Array<string[]> = [];
        let obj: string[];
        data.forEach(x => {
            obj = [];
            obj.push(x.createddate);
            obj.push(x.subregion);
            obj.push(x.sites);
            obj.push(x.businessgroup);
            obj.push(x.defectmodeaggregation);
            // obj.push(x.product);
            obj.push(x.recordid);
            obj.push(x.productionline);
            obj.push(x.defectpriorityindex.toString());
            obj.push(x.pdcastatus);
            obj.push(x.occurances.toString());
            obj.push(x.agreement);
            obj.push(x.remarks);
            obj.push(x.createdby);
            datalist.push(obj);
        });
        // Create workbook and worksheet
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('ProjectStatusReport');
        // Add Header Row
        const headerRow = worksheet.addRow(header);
        // Cell Style : Fill and Border
        headerRow.eachCell((cell, num) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add Data and Conditional Formatting
        datalist.forEach(d => {
            const row = worksheet.addRow(d);
            const qty = row.getCell(8);
            let color = 'FFFFFF';
            if (+qty.value < 500) {
                color = 'FFFFFF';
            }

            qty.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: color }
            };
        }
        );
        worksheet.getColumn(3).width = 30;
        worksheet.getColumn(4).width = 30;
        worksheet.addRow([]);
        // Footer Row
        const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
        footerRow.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' }
        };
        footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Merge Cells
        worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

        // Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((datalistExcel: any) => {
            const blob = new Blob([datalistExcel], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, 'ProjectStatusReport.xlsx');
        });
    }

    generateExcelForLossTreeReport(data: any[]) {
        const header = ['Loss Tree', 'Defect Priority Index', 'Occurances', 'Year', 'Period', 'Cluster', 'Site', 'BigCategory'];

        const datalist: Array<string[]> = [];
        let obj: string[];
        data.forEach(x => {
            obj = [];
            obj.push(x.defectmodeaggregation);
            obj.push(x.totaldefectpriorityindex.toString());
            obj.push(x.occurances.toString());
            obj.push(x.year);
            obj.push(x.period);
            obj.push(x.cluster);
            obj.push(x.site);
            obj.push(x.bigcategory);
            datalist.push(obj);
        });
        // Create workbook and worksheet
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Loss_Tree_Stats');
        // Add Header Row
        const headerRow = worksheet.addRow(header);
        // Cell Style : Fill and Border
        headerRow.eachCell((cell, num) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add Data and Conditional Formatting
        datalist.forEach(d => {
            const row = worksheet.addRow(d);
            const qty = row.getCell(8);
            let color = 'FFFFFF';
            if (+qty.value < 500) {
                color = 'FFFFFF';
            }

            qty.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: color }
            };
        }
        );
        worksheet.getColumn(1).width = 100;
        worksheet.getColumn(2).width = 20;
        worksheet.addRow([]);
        // Footer Row
        const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
        footerRow.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' }
        };
        footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Merge Cells
        worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

        // Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((datalistExcel: any) => {
            const blob = new Blob([datalistExcel], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, 'LossTreeStatsReport.xlsx');
        });
    }

    generateExcelForComparativeLossTreeReport(data: any[], reportType: string, headerReference: string, headerTarget: string) {
        const datalist: Array<string[]> = [];
        const analysisTabs = ANALYSISTABS;
        let obj: string[];
        let header1 = '';
        let header2 = '';
        if (reportType === analysisTabs[1]) {
            header1 = 'Year';
            header2 = 'Period';
            data.forEach(x => {
                obj = [];
                obj.push(x.level0);
                obj.push(x.defectmodeaggregation);
                obj.push(x.cluster);
                obj.push(x.sites);
                obj.push(x.bigcategory);
                obj.push(x.defectpriorityindexh1);
                obj.push(x.defectpriorityindexh2);
                obj.push(x.changedpi);
                obj.push(x.occurancesh1);
                obj.push(x.occurancesh2);
                obj.push(x.changeoccurances);
                obj.push(x.dpidefectclass);
                obj.push(x.defectseverity);
                obj.push(x.year);
                obj.push(x.period);
                datalist.push(obj);
            });
        } else if (reportType === analysisTabs[2]) {
            header1 = 'Reference Year';
            header2 = 'Target Year';
            data.forEach(x => {
                obj = [];
                obj.push(x.level0);
                obj.push(x.defectmodeaggregation);
                obj.push(x.cluster);
                obj.push(x.sites);
                obj.push(x.bigcategory);
                obj.push(x.defectpriorityindexy1);
                obj.push(x.defectpriorityindexy2);
                obj.push(x.changedpi);
                obj.push(x.occurancesy1);
                obj.push(x.occurancesy2);
                obj.push(x.changeoccurances);
                obj.push(x.dpidefectclass);
                obj.push(x.defectseverity);
                obj.push(x.year);
                obj.push(x.period);
                datalist.push(obj);
            });
        } else if (reportType === analysisTabs[3]) {
            header1 = 'Reference';
            header2 = 'Target';
            data.forEach(x => {
                obj = [];
                obj.push(x.level0);
                obj.push(x.defectmodeaggregation);
                obj.push(x.cluster);
                obj.push(x.sites);
                obj.push(x.bigcategory);
                obj.push(x.defectpriorityindexrhy);
                obj.push(x.defectpriorityindexthy);
                obj.push(x.changedpi);
                obj.push(x.occurancesrhy);
                obj.push(x.occurancesthy);
                obj.push(x.changeoccurances);
                obj.push(x.dpidefectclass);
                obj.push(x.defectseverity);
                obj.push(x.year);
                obj.push(x.period);
                datalist.push(obj);
            });
        }
        const header = ['Level0', 'Loss Tree', 'Cluster', 'Site', 'Big Category', 'Defect Priority Index', '', '', 'Occurances', '', '', 'DPI Defect Class', 'Defect Severity', header1, header2];
        // Create workbook and worksheet
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(reportType.trim());
        // Add Header Row
        const headerRow = worksheet.addRow(header);
        worksheet.mergeCells(`A1:A2`);
        worksheet.mergeCells(`B1:B2`);
        worksheet.mergeCells(`C1:C2`);
        worksheet.mergeCells(`D1:D2`);
        worksheet.mergeCells(`E1:E2`);
        worksheet.mergeCells(`F1:H1`);
        worksheet.getCell('F2').value = headerReference;
        worksheet.getCell('G2').value = headerTarget;
        worksheet.getCell('H2').value = '% Change';
        worksheet.getCell('F2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('F2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('G2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('G2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('H2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('H2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.mergeCells(`I1:K1`);
        worksheet.getCell('I2').value = headerReference;
        worksheet.getCell('J2').value = headerTarget;
        worksheet.getCell('K2').value = '% Change';
        worksheet.getCell('I2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('I2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('J2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('J2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('K2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' }};
        worksheet.getCell('K2').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.mergeCells(`L1:L2`);
        worksheet.mergeCells(`M1:M2`);
        worksheet.mergeCells(`N1:N2`);
        worksheet.mergeCells(`O1:O2`);

        headerRow.eachCell((cell, num) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add Data and Conditional Formatting
        datalist.forEach(d => {
            const row = worksheet.addRow(d);
        });
        worksheet.getColumn(1).width = 20;
        worksheet.getColumn(2).width = 80;
        worksheet.getColumn(3).width = 15;
        worksheet.getColumn(4).width = 15;
        worksheet.getColumn(5).width = 15;
        worksheet.addRow([]);
        // Footer Row
        const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
        footerRow.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' }
        };
        footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Merge Cells
        worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

        // Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((datalistExcel: any) => {
            const blob = new Blob([datalistExcel], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, reportType.trim() + 'Report.xlsx');
        });
    }
}
